import { render } from "./stocks.vue?vue&type=template&id=ced9714c&scoped=true&ts=true"
import script from "./stocks.vue?vue&type=script&lang=ts"
export * from "./stocks.vue?vue&type=script&lang=ts"

import "./stocks.vue?vue&type=style&index=0&id=ced9714c&lang=less"
import "./stocks.vue?vue&type=style&index=1&id=ced9714c&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced9714c"]])

export default __exports__